import React, { Component } from 'react';
// eslint-disable-next-line import/no-duplicates
import { Trans } from '@lingui/macro';
import classNames from 'classnames';
import Caption from '../components/Caption';
import Icons from '../components/Icons';
import styles from './BragifyEmbedItem.module.css';
import { contrastTextColor, ensureURLProtocol, shadeColor, getMediaType } from '../utils';
import PostFront from './PostFront';
import { AnalyticsEvents, AnalyticsScores, EmbedTypes, networks } from '../consts';

class BragifyEmbedItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      postBackStyle: {},
    };
    this.isFlipped = false;
  }

  handleLinkClick = (e) => {
    e.stopPropagation();

    this.trackClick();
  };

  handleCardFlip(evt, item, index) {
    if (evt.propertyName !== 'transform' || evt.elapsedTime < 0.5) {
      return;
    }
    const { handlePostFlipped, postsFlipped } = this.props;
    handlePostFlipped();
    if (!this.isFlipped) {
      this.isFlipped = true;
      giggAnalytics.logEvent(AnalyticsEvents.FOCUS_POST, {
        boardId: __gigg.accountId,
        boardType: EmbedTypes.GRID,
        folderId: __gigg.folderId,
        postIndex: index,
        postId: item.id,
        postType: item.service,
        mediaType: getMediaType(item.media),
        isCarousel: item.media?.length > 1,
        hasCTA: !!item.customLink?.linkUrl,
        scoreWeight:
          postsFlipped > 1 ? AnalyticsScores.SECOND_FOCUS_POST : AnalyticsScores.FOCUS_POST,
        firstEvent: {
          _id: window.giggFirstEvent?._id,
          createdDate: window.giggFirstEvent?.createdDate,
        },
        inViewEvent: {
          _id: window.latestViewEvent?._id,
          createdDate: window.latestViewEvent?.createdDate,
        },
      });

      return;
    }
    this.isFlipped = false;
  }

  trackClick() {
    const { accountId, data: item, index } = this.props;
    giggAnalytics.logEvent(AnalyticsEvents.CTA_CLICK, {
      boardId: accountId,
      boardType: EmbedTypes.GRID,
      folderId: __gigg.folderId,
      postIndex: index,
      postId: item.id,
      postType: item.service,
      mediaType: getMediaType(item.media),
      isCarousel: item.media?.length > 1,
      CTA_URL: item.customLink.linkUrl,
      scoreWeight: AnalyticsScores.CTA_CLICK,
      firstEvent: {
        _id: window.giggFirstEvent?._id,
        createdDate: window.giggFirstEvent?.createdDate,
      },
      inViewEvent: {
        _id: window.latestViewEvent?._id,
        createdDate: window.latestViewEvent?.createdDate,
      },
    });
  }

  render() {
    const {
      data: item,
      openModal,
      options,
      index,
      onMediaError,
      formatDistanceLocale,
      embedType,
    } = this.props;
    const { postBackStyle } = this.state;
    const shareURL = window.location.href;
    const thumbnails = (item.media || [])[0];
    const { customLink = {} } = item;
    const captionLength = customLink.linkUrl ? 150 : 320;

    return (
      <button
        type="button"
        className={styles.post}
        style={postBackStyle}
        aria-label={item.altText}
        onClick={() => openModal(index, item, embedType)}
      >
        <div
          className={classNames(styles.flipper__noFlip, {
            [styles.flipper]: !options.gridHideCaptions && item.media[0]?.large,
          })}
          onTransitionEnd={(evt) => {
            this.handleCardFlip(evt, item, index);
          }}
        >
          <PostFront
            item={item}
            shareURL={shareURL}
            options={options}
            onMediaError={onMediaError}
            formatDistanceLocale={formatDistanceLocale}
          />
          {thumbnails && (
            <div
              className={styles['post-back']}
              style={{
                background: shadeColor(options.secondaryColor),
                color: contrastTextColor(options.secondaryColor),
              }}
            >
              <div className={styles['post-content-wrapper']}>
                {!options.disableDates && item.service !== networks.CUSTOM && (
                  <div className={styles.ts}>
                    <span>
                      {formatDistanceLocale(new Date(item.time || 0), new Date())}{' '}
                      <Trans>ago</Trans>
                    </span>
                  </div>
                )}
                <div className={styles.caption}>
                  {!options.gridHideCaptions && (
                    <Caption
                      service={item.service}
                      color={options.primaryColor}
                      maxLength={captionLength}
                      disableLinks={options.disableHashtagLinks}
                    >
                      {item.caption}
                    </Caption>
                  )}
                </div>
                {customLink.linkText && customLink.linkUrl && (
                  <div className={styles['button-link__container']}>
                    <a
                      target="blank"
                      tabIndex="-1"
                      className={styles['button-link']}
                      onClick={this.handleLinkClick}
                      href={ensureURLProtocol(customLink.linkUrl)}
                      style={{
                        color: contrastTextColor(options.secondaryColor),
                        borderColor: contrastTextColor(options.secondaryColor),
                        textAlign: 'center',
                      }}
                    >
                      {item.customLink.linkText}
                    </a>
                  </div>
                )}
                {item.service !== networks.CUSTOM ? (
                  <div className={styles.footer}>
                    <div className={styles['user-info']}>
                      {item.profilePic && item.service !== networks.INSTAGRAM && (
                        <div className={styles['profile-image']}>
                          <img className={styles['profile-image__img']} src={item.profilePic} />
                        </div>
                      )}
                      <div className={styles['usernames-container']}>
                        {item.fullname && <div className={styles.username}>{item.fullname}</div>}
                        {item.username && (
                          <div className={styles['user-handle']}>@{item.username}</div>
                        )}
                      </div>
                    </div>
                    <div key="social-icon" className={styles['social-icon']}>
                      <Icons
                        icon={item.service}
                        color={contrastTextColor(options.secondaryColor)}
                      />
                    </div>
                  </div>
                ) : (
                  ''
                )}
              </div>
            </div>
          )}
        </div>
      </button>
    );
  }
}

export default BragifyEmbedItem;
